import { provider, storeLocatorMap, currentPosition } from "..";
import * as L from "leaflet";

export function normalizeLongitude(lon) {
    // If the longitude is exactly 180, return 180 (handle edge case)
    if (lon === 180) return 180;

    let normalized = ((lon + 180) % 360);
    if (normalized < 0) {
        normalized += 360;
    }
    return normalized - 180;
}

// Checks if a given point is within the geographical bounds defined by northeast and southwest points.
export function inBounds(point, nePoint, swPoint) {
    var eastBound = point.lng < nePoint.lng;
    var westBound = point.lng > swPoint.lng;
    var inLong;

    if (nePoint.lng < swPoint.lng) {
        inLong = eastBound || westBound;
    } else {
        inLong = eastBound && westBound;
    }

    var inLat = point.lat > swPoint.lat && point.lat < nePoint.lat;
    return inLat && inLong;
}

// Find coordinates of given corner of the map. Returns {lat, lng} object or single coordinate.
export function getMapCorner(corner, coord = null) {
    if (storeLocatorMap) {
        let bounds = storeLocatorMap.getBounds();
        if (!bounds) {
            if (coord == "lat") return 0;
            if (coord == "lng") return 0;
            return { lat: 0, lng: 0 };
        }
        switch (provider) {
            case "Google":
                switch (corner) {
                    case "ne":
                        let ne = bounds.getNorthEast();
                        if (coord == "lat") return ne.lat();
                        if (coord == "lng") return ne.lng();
                        return { lat: ne.lat(), lng: ne.lng() };
                    case "sw":
                        let sw = bounds.getSouthWest();
                        if (coord == "lat") return sw.lat();
                        if (coord == "lng") return sw.lng();
                        return { lat: sw.lat(), lng: sw.lng() };
                }
                break;
            case "Progus":
                switch (corner) {
                    case "ne":
                        let ne = bounds.getNorthEast();
                        if (coord == "lat") return ne.lat;
                        if (coord == "lng") return ne.lng;
                        return { lat: ne.lat, lng: ne.lng };
                    case "sw":
                        let sw = bounds.getSouthWest();
                        if (coord == "lat") return sw.lat;
                        if (coord == "lng") return sw.lng;
                        return { lat: sw.lat, lng: sw.lng };
                }
                break;
            default:
                switch (corner) {
                    case "ne":
                        let ne = bounds._northEast;
                        if (coord == "lat") return ne.lat;
                        if (coord == "lng") return ne.lng;
                        return ne;
                    case "sw":
                        let sw = bounds._southWest;
                        if (coord == "lat") return sw.lat;
                        if (coord == "lng") return sw.lng;
                        return sw;
                }
                break;
        }
    }
}

// Get current map center cooridnates, depending on selected provider
export function getMapCenter(coord = null) {
    if (storeLocatorMap) {
        let center = storeLocatorMap.getCenter();
        switch (provider) {
            case "Google":
                if (coord == "lat") return center.lat();
                if (coord == "lng") return center.lng();
                return center;
            default:
                if (coord == "lat") return center.lat;
                if (coord == "lng") return center.lng;
                return center;
        }
    }
}

// get max distance from map center - required for /locations requests
export function getMaxDistanceFromCenter() {
    let distance = 10000;
    let neLat = getMapCorner("ne", "lat");
    let neLng = getMapCorner("ne", "lng");
    let swLat = getMapCorner("sw", "lat");
    let swLng = getMapCorner("sw", "lng");
    let centerLat = getMapCenter("lat");
    let centerLng = getMapCenter("lng");
    let centerPoint = L.latLng(centerLat, centerLng);
    distance = centerPoint.distanceTo(L.latLng(neLat, neLng)).toFixed(0) / 1000;
    let southWestdistance = centerPoint.distanceTo(L.latLng(swLat, swLng)).toFixed(0) / 1000;
    if (southWestdistance > distance) distance = southWestdistance;
    if (distance < 25) distance = 25;
    if (distance > 10000) distance = 100000;
    return distance;
}

// calculate distance from center to provided locations
export function calculateDistances(locations) {
    let centerLat = getMapCenter("lat");
    let centerLng = getMapCenter("lng");
    let centerPoint = L.latLng(centerLat, centerLng);
    if (currentPosition) {
      centerPoint = L.latLng(currentPosition[0], currentPosition[1]);
    }
    for (let location of locations) {
      location.d = (centerPoint.distanceTo(L.latLng(location.lat, location.lon)) / 1000).toFixed(1);
    }
    return locations;
  }